<template>
  <div class="step-question-template medical-step-question" v-if="isUs">
    <div class="question-text">{{ question.anyMedicineQuestion }}</div>
    <YesNo v-model="any" :yes="true" :no="false" :id="'any-' + question.id" />

    <div class="question-error" v-if="anyErrorMessage">
      {{ anyErrorMessage }}
    </div>

    <div v-if="any">
      <div class="question-text" style="margin-top: 60px" v-html="question.contraindicationQuestion"></div>
      <div class="question-text">
        <ul class="question-points">
          <li v-for="(point, idx) in question.contraindications" :key="idx">
            <span v-html="point"></span>
          </li>
        </ul>
      </div>
      <YesNo v-model="contraindicated" :yes="true" :no="false" :id="'contraindicated-' + question.id" />

      <div class="question-error" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>
  <div v-else>
    <div class="row question-row question-row-wrapped" :style="first ? { borderTop: 'none' } : {}">
      <div style="word-wrap: break-all">
        <span class="question-text" v-html="question.anyMedicineQuestion" />
      </div>

      <div>
        <YesNo v-model="any" :yes="true" :no="false" :id="'any-' + question.id" />
      </div>
    </div>

    <div class="row error-row">
      <div
        v-if="anyErrorMessage"
        :style="['margin-left: 15px; max-width: 80%;']"
        class="ui-message ui-message-error ui-widget ui-corner-all"
      >
        <span class="ui-message-error-icon"></span>
        <span class="ui-message-error-detail">{{ anyErrorMessage }}</span>
      </div>
    </div>

    <div v-if="any">
      <div class="row question-row question-row-wrapped">
        <div style="word-wrap: break-all">
          <span class="question-text" v-html="question.contraindicationQuestion"></span>

          <ul class="question-points points-wrapped">
            <li v-for="point in question.contraindications" :key="point">
              <span v-html="point" />
            </li>
          </ul>
        </div>

        <div>
          <YesNo v-model="contraindicated" :yes="true" :no="false" :id="'contraindicated-' + question.id" />
        </div>
      </div>

      <div class="row error-row">
        <div
          v-if="errorMessage"
          :style="['margin-left: 15px; max-width: 80%;']"
          class="ui-message ui-message-error ui-widget ui-corner-all"
        >
          <span class="ui-message-error-icon" />
          <span class="ui-message-error-detail" v-html="errorMessage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import poster from "../mixins/poster";
import responseAdapters from "../mixins/responseAdapters";
import validator from "../mixins/validator";
import YesNo from "./YesNo.vue";

export default Vue.extend({
  mixins: [poster, validator],
  inject: ["isUs", "submitUrl", "csrfHeader", "csrf"],
  components: {
    YesNo,
  },
  props: {
    question: { required: true },
    showRequired: { required: true },
    first: { required: true },
    validate: { required: false, default: true },
  },
  data() {
    return {
      any: this.question.isTakingAnyMedicine,
      contraindicated: this.question.isTakingContraindicated,
      responseAdapter: responseAdapters.medical,
      initialAny: null,
      initialContraindicated: null,
    };
  },
  created() {
    this.$emit("answer", this.question, this.responseAdapter(this.question));
    if ((this.any && this.contraindicated != null) || this.any === false) {
      this.hasDefaultAnswer = true;
      this.$emit("update-next-button-status", true);
    }

    this.initialAny = this.any;
    this.initialContraindicated = this.contraindicated;
  },
  computed: {
    errorMessage() {
      if (this.validate && this.valid === false) {
        return this.question.rejectMessage;
      }

      if (this.showRequired && this.contraindicated === null) {
        return "You must answer the question to continue";
      }

      return null;
    },
    anyErrorMessage() {
      if (this.showRequired && this.any === null) {
        return "You must answer the question to continue";
      }

      return null;
    },
    valid() {
      if (this.any === null) {
        return null;
      }
      if (this.any) {
        if (this.contraindicated === null) {
          return null;
        }

        if (this.validate && this.contraindicated) {
          return false;
        }
      }

      return true;
    },
  },
  watch: {
    any(newValue) {
      if (_.isNull(this.initialAny)) {
        this.initialAny = newValue;
      }

      this.question.isTakingAnyMedicine = newValue;
      this.question.isChangedAnswer = this.question.isChangedAnswer || newValue !== this.initialAny;

      if (newValue === false) {
        this.contraindicated = null;
        this.save();
      }

      this.$emit("any-input-changed", newValue);

      if (this.isUs && !this.hasDefaultAnswer) {
        if (newValue === false) {
          this.$emit("next", this.question.id, false);
        } else {
          this.$emit("update-next-button-status", true);
        }
      }
    },
    contraindicated(newValue) {
      if (_.isNull(this.initialContraindicated)) {
        this.initialContraindicated = newValue;
      }

      this.question.isTakingContraindicated = newValue;
      this.question.isChangedAnswer = this.question.isChangedAnswer || newValue !== this.initialContraindicated;

      this.save();
    },
  },
  methods: {
    save() {
      this.post(this.responseAdapter(this.question));
    },
  },
});
</script>
